import { useTheme } from "@hooks";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.chart.projection.inverted.background,
    },
  };

  return styles;
};
